var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.circular)?_c('WidgetCircularDiagram',{attrs:{"items":_vm.items.length === 0 ? _vm.noData : _vm.items,"large-data":_vm.largeData,"show-percent":_vm.showPercent,"compact":_vm.compact}}):_c('WidgetHorizontalDiagram',{attrs:{"items":_vm.items.length === 0 ? _vm.noData : _vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }